'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
  showText?: boolean;
  textColor?: string;
  iconOnly?: boolean;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
  showText = false,
  textColor = '#E8650A',
  iconOnly = false,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center gap-2'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const iconSize = size;

  return (
    <div className={containerClassName} onClick={onClick}>
      {/* Orange hard hat icon */}
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
        aria-label="RHO Bouwtechniek logo"
      >
        {/* Hard hat dome */}
        <path
          d="M10 38 C10 22 20 12 32 12 C44 12 54 22 54 38"
          fill="#E8650A"
          stroke="#E8650A"
          strokeWidth="1"
        />
        {/* Hard hat brim */}
        <rect x="6" y="36" width="52" height="6" rx="3" fill="#E8650A" />
        {/* Hard hat inner band */}
        <path
          d="M16 38 C16 26 23 18 32 18 C41 18 48 26 48 38"
          fill="#C4520A"
          opacity="0.4"
        />
        {/* Ventilation stripe */}
        <rect x="29" y="12" width="6" height="26" rx="3" fill="#C4520A" opacity="0.35" />
      </svg>

      {/* Company name text */}
      {!iconOnly && showText && (
        <div className="flex flex-col leading-none">
          <span
            style={{
              color: textColor,
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: `${Math.round(iconSize * 0.38)}px`,
              fontWeight: 700,
              letterSpacing: '0.04em',
              lineHeight: 1.1,
            }}
          >
            RHO
          </span>
          <span
            style={{
              color: textColor,
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: `${Math.round(iconSize * 0.22)}px`,
              fontWeight: 600,
              letterSpacing: '0.12em',
              lineHeight: 1.2,
            }}
          >
            BOUWTECHNIEK
          </span>
        </div>
      )}
    </div>
  );
});

export default AppLogo;
